<div class="contact-fields" [formGroup]="contactForm">
  <div class="form-row">
    <mat-form-field appearance="outline" class="form-field">
      <mat-label>First Name</mat-label>
      <input matInput formControlName="firstName" placeholder="Enter first name" [readonly]="readonly">
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Last Name</mat-label>
      <input matInput formControlName="lastName" placeholder="Enter last name" [readonly]="readonly">
    </mat-form-field>
  </div>

  <div class="form-row">
    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Email</mat-label>
      <input matInput type="email" formControlName="email" placeholder="Enter email address" [readonly]="readonly">
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Phone</mat-label>
      <input matInput type="tel" formControlName="phone" placeholder="Enter phone number" [readonly]="readonly">
    </mat-form-field>
  </div>

  <div class="form-row" style="display: none;">
    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Address ID</mat-label>
      <input matInput type="number" formControlName="addressId" placeholder="Enter address ID (optional)">
    </mat-form-field>
  </div>
</div>
